import { render, staticRenderFns } from "./IndividualProfileUpdate.vue?vue&type=template&id=cf83bb26&scoped=true&"
import script from "./IndividualProfileUpdate.vue?vue&type=script&lang=js&"
export * from "./IndividualProfileUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf83bb26",
  null
  
)

export default component.exports